import { render, staticRenderFns } from "./PanelFacts.vue?vue&type=template&id=2877006c&"
import script from "./PanelFacts.vue?vue&type=script&lang=js&"
export * from "./PanelFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports